import { EditorState } from 'draft-js'
import decorateComponentWithProps from 'decorate-component-with-props'
import DefaultColorBlock from './SubBlock'
import DefaultAddColorBlockButton from './AddColorBlockButton'
import { insertColorBlock } from './modifiers'
import styles from './styles.css'

export default (config = {}) => {
  const defaultTheme = styles

  const {
    theme = defaultTheme,
    labelText,
    tooltipText,
    ColorBlock,
  } = config

  const store = {
    getEditorState: undefined,
    setEditorState: undefined,
    setReadOnly: undefined,
  }

  const DecoratedColorBlock = ColorBlock || decorateComponentWithProps(DefaultColorBlock, {
    // foo: 'bar',
  })

  return {
    initialize: ({ setEditorState, getEditorState, setReadOnly }) => {
      store.getEditorState = getEditorState
      store.setEditorState = setEditorState
      store.setReadOnly = setReadOnly
    },
    decorator: [
      {
        strategy,
        component: DecoratedColorBlock,
      },
    ],

    blockRendererFn: (block, {
      getEditorState, setEditorState,
      setReadOnly,
    }) => {
      if (block.getType() === 'atomic') {
        return {
          component: DecoratedColorBlock,
          editable: true,
          props: {
            onStartEdit: () => setReadOnly(true), // put focus on SubEditor

            onFinishEdit: (newContentState, shouldRestoreFocus) => {
              const newEditorState = EditorState.createWithContent(newContentState)
              setEditorState(newEditorState)

              if (shouldRestoreFocus) {
                setReadOnly(false)
              }
            },

            updateBackgroundColor: (entityKey, newBackgroundColor) => {
              const contentState = getEditorState().getCurrentContent()
              const currEntityData = contentState.getEntity(entityKey).get('data')
              const nextEntityData = {
                styles: {
                  ...currEntityData.styles,
                  backgroundColor: newBackgroundColor,
                },
              }

              const newContentState = contentState.mergeEntityData(
                entityKey,
                nextEntityData,
              )

              const newEditorState = EditorState.createWithContent(newContentState)
              setEditorState(newEditorState)
            },
          },
        }
      }

      return null
    },

    AddColorBlockButton: decorateComponentWithProps(DefaultAddColorBlockButton, {
      ownTheme: theme,
      store,
      labelText,
      tooltipText,
    }),
    insertColorBlock,
  }
}

const isColorBlock = entType => entType === 'colorblock'

function strategy(contentBlock, cb, contentState) {
  if (!contentBlock) { return }

  contentBlock.findEntityRanges((character) => {
    const entityKey = character.getEntity()

    return (
      entityKey !== null &&
      isColorBlock(contentState.getEntity(entityKey).getType())
    )
  }, cb)
}



// WEBPACK FOOTER //
// ./src/components/sitewide/RichTextEditor/ColorBlock/plugin.js